import type { NetworkData } from '@dynamic-labs-sdk/client';
import type { Chain } from 'viem';

/**
 * Created a viem Chain object from a NetworkData object.
  * @not-instrumented
 */
export const mapNetworkDataToViemChain = (networkData: NetworkData): Chain => ({
  blockExplorers: networkData.blockExplorerUrls?.[0]
    ? {
        default: {
          name: networkData.blockExplorerUrls[0],
          url: networkData.blockExplorerUrls[0],
        },
      }
    : undefined,
  id: Number(networkData.networkId),
  name: networkData.displayName,
  nativeCurrency: networkData.nativeCurrency,
  rpcUrls: {
    default: { http: networkData.rpcUrls.http },
  },
});
